import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documents-user',
  templateUrl: './documents-user.component.html',
  styleUrls: ['./documents-user.component.css']
})
export class DocumentsUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
